import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownAchievementGroups = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, isPost16, onChange, initialValue } ) =>
{
    const param = isPost16 ? '?post16' : '' ;

    const url =  "/achievementgroups" + param ;

    const [ loading, items ] = useListboxFetch( {
        url: url, keyFieldName: 'achievement_group_id', labelFieldName: 'achievement_group_desc' } ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} onChange={onChange} initialValue={initialValue} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownAchievementGroups;
